module.exports = __webpack_public_path__ + "img/fail.30db1151.png";